import { DiscountUnit } from "../../../../../../../redux/services/Order/getPhoneInfo";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model, lang: string): string => {
	const customerDiscountPlans =
		item?.cost?.settings?.customerDiscountPlans ?? [];

	const mainPlan = customerDiscountPlans.find((plan) => plan.type === "main");
	const additionalPlan = customerDiscountPlans.find(
		(plan) => plan.type === "additional",
	);

	const mainT = mainPlan ? mainPlan.name?.[lang] ?? "" : "";
	const additionalT = additionalPlan ? additionalPlan.name?.[lang] ?? "" : "";

	const currencyName = item?.cost?.currency?.settings?.name ?? "";

	const formatDiscount = (plan?: typeof mainPlan) => {
		if (!plan || !plan.conciseSettings?.discount) return "0";

		const { unit, value } = plan.conciseSettings.discount;
		if (unit === DiscountUnit.Amount) return `${value}${currencyName}`;
		return `${value}%`;
	};

	const formatMaxDiscount = (plan?: typeof mainPlan) => {
		if (!plan || !plan.conciseSettings?.maxDiscount) return "";
		const { active, value } = plan.conciseSettings.maxDiscount;
		if (!active) return "";
		return `<= ${value}${currencyName}`;
	};

	const mainDiscount = formatDiscount(mainPlan);
	const mainDiscountMax = formatMaxDiscount(mainPlan);
	const mainDiscountActive = mainPlan?.active;

	const additionalDiscount = formatDiscount(additionalPlan);
	const additionalDiscountMax = formatMaxDiscount(additionalPlan);
	const additionalDiscountActive = additionalPlan?.active;

	const active = item.additionalFields?.discount?.active ?? "";

	if (!active) return "";

	const main = mainDiscountActive
		? `${mainT}: ${mainDiscount} ${mainDiscountMax}`.trim()
		: "";
	const additional = additionalDiscountActive
		? `${additionalT}: ${additionalDiscount} ${additionalDiscountMax}`.trim()
		: "";

	return `${main}${additional ? ", " : ""}${additional}`.trim();
};

export default cellProcessing;
